import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'a-button-close',
    templateUrl: './a-button-close.component.html',
    styleUrls: ['./a-button-close.component.scss'],
    standalone: false
})
export class AButtonCloseComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}
